import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { DocumentSort } from '../../services';

export const fetchDocumentSort = createAsyncThunk(
    'documentSort/fetchDocumentSort',
    async ({ id, sort }) => {
        const response = await DocumentSort(id, sort)
        return response.result
    }
)

const documentSortSlice = createSlice({
    name: 'documentSort',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDocumentSort.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDocumentSort.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchDocumentSort.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default documentSortSlice.reducer;
